import React from 'react';
import { Modal, Button } from 'rsuite';

export default function ConfirmModal ({ show, setOpenConfirmModal, handleDownload }) {
    const handleClose = () => setOpenConfirmModal(false);

    const handleConfirm = () => {
        setOpenConfirmModal(false);
        handleDownload();
    };

    return (
        <Modal size='sm' open={show} onClose={handleClose}>
            <Modal.Header>
                <Modal.Title>Atención</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6 className="modal-body"> La descarga demora aproximadamente 10 min, desea continuar</h6>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleConfirm} appearance="primary">
                    Confirmar
                </Button>
                <Button onClick={handleClose} appearance="subtle">
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
